import { useContext } from 'react';
import { PWAInstallContext } from '@/context/PWAInstallContext';

export default function PWAInstallBanner() {
  const { showBanner, promptInstall, dismissBanner } = useContext(PWAInstallContext);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-[72px] md:bottom-6 left-3 right-3 md:left-auto md:right-6 md:w-96 z-50 animate-slide-up">
      <div className="bg-background-50 border border-background-200/80 rounded-2xl p-4 flex items-center gap-4 shadow-lg">
        {/* App Icon */}
        <div className="w-12 h-12 rounded-xl bg-primary-500 flex items-center justify-center flex-shrink-0 overflow-hidden">
          <span className="text-background-50 font-heading font-bold text-xl leading-none">J</span>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-heading font-semibold text-foreground-950 leading-tight">
            Add JOVIAA to Home Screen
          </p>
          <p className="text-xs text-foreground-500 leading-tight mt-0.5">
            Quick access, no browser tabs needed
          </p>
        </div>

        {/* Install Button */}
        <button
          onClick={promptInstall}
          className="flex-shrink-0 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-label font-semibold rounded-full whitespace-nowrap transition-colors duration-200 cursor-pointer"
        >
          Install
        </button>

        {/* Dismiss */}
        <button
          onClick={dismissBanner}
          className="absolute -top-2 -right-2 w-6 h-6 bg-background-100 hover:bg-background-200 text-foreground-400 hover:text-foreground-600 rounded-full flex items-center justify-center transition-colors duration-200 cursor-pointer"
          aria-label="Dismiss"
        >
          <i className="ri-close-line text-xs"></i>
        </button>
      </div>
    </div>
  );
}